import React, { useEffect, useState } from "react";
import { mutantColors } from "../../../app/assets/styles/themes/default";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as LogoMutant } from "../../../app/assets/logos/logo-mutant.svg";
import { Link } from "react-router-dom";
import store from "../../../app/store/store";
import * as authDuck from "../../../app/store/ducks/auth.duck";
import { ReactComponent as ExitIcon } from "../../../app/assets/icons/icon_exit.svg";
import { Button, Typography, Grid, Container, Box } from "@material-ui/core";
import { MutantApiService } from "../../../app/services/MutantApiService";
import { ReactComponent as PipeIcon } from "../../../app/assets/icons/icon_pipe.svg";
import { ReactComponent as BlackboltUserIcon } from "../../../app/assets/icons/icon_blackbolt_user.svg";
import moment from "moment";
import { Dropdown } from "react-bootstrap";
const dateTimeFormat = "DD/MM/YYYY";

const StyledButton = styled.button`
	box-sizing: border-box;
	color: ${props => (props.active ? mutantColors.l_blue_1 : "white")};
	background-color: transparent;
	border: none;
	margin: 0 5px;
	cursor: pointer;
	text-decoration: none;
	background: none;
	padding: 8px 16px;
	position: relative;
	font-size: 14px;
	font-weight: 500;
	transition: all 0.3s ease;

	&::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 3px;
		background-color: ${mutantColors.l_blue_1};
		display: ${props => (props.active ? "block" : "none")};
		border-radius: 3px 3px 0 0;
		transition: all 0.3s ease;
	}
	
	&:hover {
		background-color: rgba(255, 255, 255, 0.1);
		color: ${mutantColors.l_blue_1};
	}
	
	&:focus {
		box-shadow: none;
		outline: none;
		background-color: rgba(255, 255, 255, 0.1);
	}
	
	@media (max-width: 1200px) {
		margin: 0 3px;
		padding: 6px 12px;
		font-size: 13px;
	}
	
	@media (max-width: 768px) {
		margin: 0 2px;
		padding: 5px 8px;
		font-size: 12px;
	}
	
	@media (max-width: 480px) {
		margin: 0 1px;
		padding: 4px 6px;
		font-size: 11px;
	}
`;

const DropdownToggle = styled(Dropdown.Toggle)`
	box-sizing: border-box;
	color: ${props => (props.active ? mutantColors.l_blue_1 : "white")};
	background-color: transparent;
	border: none;
	margin: 0 5px;
	cursor: pointer;
	text-decoration: none;
	background: none;
	padding: 8px 16px;
	position: relative;
	font-size: 14px;
	font-weight: 500;
	transition: all 0.3s ease;

	&::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 3px;
		background-color: ${mutantColors.l_blue_1};
		display: ${props => (props.active ? "block" : "none")};
		border-radius: 3px 3px 0 0;
		transition: all 0.3s ease;
	}
	
	&:hover {
		background-color: rgba(255, 255, 255, 0.1);
		color: ${mutantColors.l_blue_1};
	}
	
	&:focus {
		box-shadow: none;
		outline: none;
		background-color: rgba(255, 255, 255, 0.1);
	}
	
	@media (max-width: 1200px) {
		margin: 0 3px;
		padding: 6px 12px;
		font-size: 13px;
	}
	
	@media (max-width: 768px) {
		margin: 0 2px;
		padding: 5px 8px;
		font-size: 12px;
	}
	
	@media (max-width: 480px) {
		margin: 0 1px;
		padding: 4px 6px;
		font-size: 11px;
	}
`;

const DropdownMenu = styled(Dropdown.Menu)`
	background-color: ${mutantColors.d_blue_4};
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 8px;
	margin-top: 5px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
	min-width: 150px;
	
	.dropdown-item {
		color: white;
		padding: 10px 16px;
		font-size: 14px;
		font-weight: 500;
		transition: all 0.3s ease;
		
		&:hover {
			background-color: rgba(255, 255, 255, 0.1);
			color: ${mutantColors.l_blue_1};
		}
		
		&:focus {
			background-color: rgba(255, 255, 255, 0.1);
			color: ${mutantColors.l_blue_1};
		}
		
		&.active {
			background-color: rgba(255, 255, 255, 0.15);
			color: ${mutantColors.l_blue_1};
		}
	}
	
	@media (max-width: 768px) {
		min-width: 120px;
		
		.dropdown-item {
			padding: 8px 12px;
			font-size: 13px;
		}
	}
	
	@media (max-width: 480px) {
		min-width: 100px;
		
		.dropdown-item {
			padding: 6px 10px;
			font-size: 12px;
		}
	}
`;

const styles = {
	navbar: {
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "space-between",
		alignItems: "center",
		minHeight: "50px",
		position: "fixed",
		top: 0,
		left: 0,
		right: 0,
		zIndex: 1000,
		margin: 0,
		padding: "5px 0",
		width: "100%",
		boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)"
	}
};

const LogoLink = styled(Link)`
	margin: 0;
	padding: 0;
	display: inline-flex;
	align-items: center;
`;

const StyledLogo = styled(LogoMutant)`
	height: 20px;
	fill: #fff;
	margin-left: 30px;
	transition: all 0.3s ease;

	&:hover {
		transform: scale(1.05);
	}

	@media (max-width: 768px) {
		height: 18px;
		margin-left: 15px;
	}

	@media (max-width: 480px) {
		height: 16px;
		margin-left: 10px;
	}
`;

const ButtonContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	flex-wrap: wrap;
	justify-content: center;
	
	@media (max-width: 1200px) {
		gap: 3px;
	}
	
	@media (max-width: 768px) {
		gap: 2px;
		flex-wrap: nowrap;
		overflow-x: auto;
		justify-content: flex-start;
		padding: 0 10px;
		
		&::-webkit-scrollbar {
			height: 3px;
		}
		
		&::-webkit-scrollbar-track {
			background: rgba(255, 255, 255, 0.1);
		}
		
		&::-webkit-scrollbar-thumb {
			background: ${mutantColors.l_blue_1};
			border-radius: 3px;
		}
	}
	
	@media (max-width: 480px) {
		gap: 1px;
		padding: 0 5px;
	}
`;


const truncateName = () => {
	const firstName = store.getState().auth?.user?.firstName;
	const lastName = store.getState().auth?.user?.lastName;
	const fullName = `${firstName} ${lastName}`;
	if (fullName.length > 30) {
		return fullName.substring(0, 30) + "...";
	}
	return fullName;
};

export const MutantNavbar = ({ menuItems }) => {
	const history = useHistory();
	const handleLogout = async () => {
		const api = new MutantApiService();
		store.dispatch(authDuck.actions.logout());
		await api.makeHttpRequest({
			url: "/auth/logout",
			method: "POST"
		});
		history.push("/login");
	};

	const api = new MutantApiService();
	const { auth } = store.getState();

	const [_state, setState] = useState({
		id: 0,
		expiresAt: moment(new Date()).format(dateTimeFormat),
		isLoading: false,
		userLogged: auth.user,
		nodesLimitForStreaming: 0,
		usersPerNodeLimit: 0,
		nodePoolsLimitForFileSynthesis: 0,
		nodesPerNodePoolLimitForFileSynthesis: 0,
		audioVolumeControl: 1.0,
		audioStartEndTime: 0,
		audioEndTime: 0,
		enableGpuFileSynthesis: false,
		limitOfLinesOnFileForGpu: 100,
		limitOfSessionsForGpuFileSynthesis: 10,
		maintenanceMode: false
	});
	const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
	const loadData = async () => {
		const settings = await api.makeHttpRequest({
			url: `/settings`,
			method: "GET"
		});
		setState({
			nodesLimitForStreaming: settings.nodesLimitForStreaming || 0,
			usersPerNodeLimit: settings.usersPerNodeLimit || 0,
			nodePoolsLimitForFileSynthesis:
				settings.nodePoolsLimitForFileSynthesis || 0,
			nodesPerNodePoolLimitForFileSynthesis:
				settings.nodesPerNodePoolLimitForFileSynthesis || 0,
			audioVolumeControl: settings.audioVolumeControl || 1.0,
			audioStartEndTime: settings.audioStartEndTime || 0,
			enableGpuFileSynthesis: settings.enableGpuFileSynthesis || false,
			limitOfLinesOnFileForGpu: settings.limitOfLinesOnFileForGpu || 100,
			limitOfSessionsForGpuFileSynthesis:
				settings.limitOfSessionsForGpuFileSynthesis || 10,
			isLoading: false,
			apiData: settings,
			maintenanceMode: settings.maintenanceMode || false
		});
	};
	useEffect(() => {
		loadData();
	}, []);

	const [backgroundColorAlert, setBackgroundColorAlert] = useState("red");

	useEffect(() => {
		const intervalId = setInterval(() => {
			setBackgroundColorAlert(prevColor =>
				prevColor === "red" ? "#a14805" : "red"
			);
		}, 1000);

		return () => clearInterval(intervalId);
	}, []);

	// useEffect(() => {
	// 	const checkMaintenanceMode = async () => {
	// 		try {
	// 			const settings = await api.makeHttpRequest({
	// 				url: `/settings`,
	// 				method: "GET"
	// 			});
	// 			setIsMaintenanceMode(settings.maintenanceMode);
	// 		} catch (error) {
	// 			console.error("Erro ao verificar o modo de manutenção", error);
	// 		}
	// 	};

	// 	// const intervalId = setInterval(checkMaintenanceMode, 60000);
	// 	checkMaintenanceMode();
	// 	// return () => clearInterval(intervalId);
	// }, []);

	const renderMenuItem = (item, index) => {
		// Se o item tem submenu, renderiza como dropdown
		if (item.submenu && item.submenu.length > 0) {
			const isActive = item.submenu.some(subItem => 
				history.location.pathname.includes(subItem.page)
			);
			
			return (
				<Dropdown key={item.title || index}>
					<DropdownToggle
						active={isActive}
						variant="link"
						id={`dropdown-${index}`}
					>
						{item.title}
					</DropdownToggle>
					<DropdownMenu>
						{item.submenu.map((subItem, subIndex) => (
							<Dropdown.Item
								key={subItem.title || subIndex}
								onClick={() => history.push(subItem.page)}
								active={history.location.pathname.includes(subItem.page)}
							>
								{subItem.title}
							</Dropdown.Item>
						))}
					</DropdownMenu>
				</Dropdown>
			);
		}
		
		// Se não tem submenu, renderiza como botão normal
		return (
			<StyledButton
				key={item.title || index}
				active={history.location.pathname.includes(item.page)}
				onClick={() => history.push(item.page)}
			>
				{item.title}
			</StyledButton>
		);
	};

	return (
		<Grid
			container
			spacing={0}
			sm={12}
			style={{
				backgroundColor: mutantColors.d_blue_4,
				...styles.navbar
			}}
		>
			<Grid item xs={3} sm={3} md={3}>
				<LogoLink to="/">
					<StyledLogo
						fill="#FFFFFF"
						color="#FFF"
						style={{
							height: "20px",
							marginLeft: "30px"
						}}
					/>
				</LogoLink>
				<Link to="/maintenance">
					<Typography
						variant="h6"
						className="title-header"
						style={{
							color: "#FFF",
							marginRight: "20px",
							fontSize: "14px",
							backgroundColor: backgroundColorAlert,
							height: "30px",
							padding: "5px",
							borderRadius: "5px",
							display: isMaintenanceMode ? "flex" : "none",
							alignItems: "center",
							justifyContent: "center",
							width: "200px",
							userSelect: "none"
						}}
					>
						EM MANUTENÇÃO
					</Typography>
				</Link>
			</Grid>
			<Grid
				item
				xs={6}
				sm={6}
				md={6}
				style={{
					display: "flex",
					justifyContent: "center"
				}}
			>
				<ButtonContainer>
					{menuItems?.aside?.items.map((item, index) => 
						renderMenuItem(item, index)
					)}
				</ButtonContainer>
			</Grid>
			<Grid
				item
				xs={3}
				sm={3}
				md={3}
				style={{
					display: "flex",
					justifyContent: "flex-end",
					alignItems: "center"
				}}
			>
				<div
					style={{
						display: "flex",
						alignItems: "center"
					}}
				>
					<BlackboltUserIcon
						style={{ height: "30px", marginRight: "10px" }}
						stroke="#FFF"
					/>
					<Typography
						style={{
							color: "#FFF",
							marginRight: "20px",
							fontSize: "14px"
						}}
					>
						{`${truncateName()}`}
					</Typography>
					<PipeIcon stroke="#FFF" />
					<Button onClick={handleLogout} title="Sair">
						<ExitIcon
							style={{ height: "30px", marginRight: "10px" }}
							stroke="#FFF"
						/>
					</Button>
				</div>
			</Grid>
		</Grid>
	);
};

export default MutantNavbar;
